import React from "react";
import { Table } from "react-bootstrap";

export default function SalesDataTable(props) {
  const { tableStyle, tableData } = props;
  return (
    <>
      {" "}
      <Table borderless responsive className="bg-light">
        <thead style={tableStyle}>
          <tr>
            <th>Order ID</th>
            <th>Product ID</th>
            <th>Username</th>
            <th>Date</th>
            <th>State</th>
            <th>Product</th>
            <th>Quantity</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((data, index) => {
            return (
              <tr key={index}>
                <td>{data?.order_id}</td>
                <td>{data?.product_id}</td>
                <td>{data?.user_name}</td>
                <td>{data?.order_date}</td>
                <td>
                  {data?.state}
                </td>
                <td>{data?.product_name}</td>
                <td>{data?.quantity}</td>
                <td>{data?.offer_price * data?.quantity}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
}
